const getBalance = (params) => {
    const { assetName, balances, walletAccount } = params;
    const walletAccountBalances = balances.balances[walletAccount];
    if (!walletAccountBalances) {
        throw new Error(`Unknown wallet account ${walletAccount}`);
    }
    const assetBalances = walletAccountBalances[assetName];
    if (!assetBalances) {
        throw new Error(`Unknown asset ${assetName}`);
    }
    return assetBalances.spendable || assetBalances.spendableBalance || assetBalances.balance;
};
export default getBalance;
